import * as templateDocumentHooks from "@rentiohq/shared-frontend/dist/reduxV2/templateDocuments/templateDocument.hooks";
import * as templateDocumentUtils from "@rentiohq/shared-frontend/dist/reduxV2/templateDocuments/templateDocument.utils";
import {
  ETemplateDocumentStatus,
  IContract,
} from "@rentiohq/shared-frontend/dist/types/contract.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import StatusDot, { EStatus } from "../StatusDot";
interface IProps {
  contract: IContract;
}

const StatusDotTemplateDocumentContract = (props: IProps) => {
  const { contract } = props;

  // Template documents
  const { items: contractTemplateDocuments } = templateDocumentHooks.usePaged({
    shouldRefetch: true,
    query: templateDocumentUtils.getContractTemplateDocumentsQuery({
      contractId: contract.id,
    }),
  });

  // Helpers
  const getStatus = () => {
    if (contract.manuallyCompletedTemplateDocumentContract) {
      return EStatus.Success;
    }

    const templateDocument = contractTemplateDocuments?.[0];

    if (templateDocument) {
      const { status } = templateDocument;

      switch (status) {
        default:
        case ETemplateDocumentStatus.Failed:
          return EStatus.Error;

        case ETemplateDocumentStatus.New:
        case ETemplateDocumentStatus.Generating:
          return EStatus.Warning;

        case ETemplateDocumentStatus.Generated:
          return EStatus.Success;
      }
    }

    return EStatus.Error;
  };

  // Render
  const renderTooltipContent = () => {
    if (!contract) {
      return;
    }

    if (contract.manuallyCompletedTemplateDocumentContract) {
      return getLocalizedText(
        contract.manuallyCompletedTemplateDocumentContract,
      );
    }

    const templateDocument = contractTemplateDocuments?.[0];
    const { status = ETemplateDocumentStatus.Incomplete } =
      templateDocument || {};

    return getLocalizedText(`template_document.status.${status}`.toLowerCase());
  };

  return (
    <StatusDot status={getStatus()} tooltipContent={renderTooltipContent()} />
  );
};

// eslint-disable-next-line import/no-default-export
export default StatusDotTemplateDocumentContract;
